import React from 'react';
import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Home from './pages/Home';
import EditJob from './pages/EditJob';
import AddNewJob from './pages/AddNewJob';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/add-job" element={<AddNewJob />} />
        <Route path="/edit-job/:jobId" element={<EditJob />} />
        <Route path="*" element={<h1 style={{ color: "white" }}>No match</h1>} />
      </Routes>
    </BrowserRouter>
  )
}
